module.exports = __webpack_public_path__ + "img/long-term.4ec6742d.png";